import { FC } from 'react';
import { useDownloadConversationTranscript } from '@/entities/conversations';
import type { FileDownloadFormat } from '@/shared/lib';
import { DownloadFormatButton } from '@/shared/ui';

type Props = {
  dialogId: number;
};

export const DownloadTranscriptButton: FC<Props> = ({ dialogId }) => {
  const { mutate: download, isPending } = useDownloadConversationTranscript();

  const handleDownload = (format: FileDownloadFormat) => {
    download({ id: dialogId, format });
  };

  return <DownloadFormatButton onDownload={handleDownload} isPending={isPending} />;
};
